.container {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  overflow-y: auto;
  gap: 0.8rem;
  height: 100%;

  @media screen and (min-width: $bp-medium) {
    flex-direction: row;
    gap: 1.6rem;
    overflow: hidden;
  }
}

.left-container {
  flex: 1 1 60%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  min-width: 0;
  max-height: 60%;

  @media screen and (min-width: $bp-medium) {
    flex: 1 2 75%;
    max-height: unset;
    padding: 1.6rem 0 1.6rem 1.6rem;

    & > div {
      min-height: 0;
    }
  }
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;

  @media screen and (max-width: #{$bp-medium - 1}) {
    display: none;
  }
}

.info {
  display: flex;
  align-items: center;
  position: relative;
  gap: 0.8rem;
}

.left-footer {
  display: flex;
  align-items: center;
  margin: 0 0.8rem;

  @media screen and (min-width: $bp-medium) {
    flex-direction: column;
    gap: 1.6rem;
    align-items: flex-start;
    justify-content: space-between;
    margin: 0;
  }

  @media screen and (min-width: $bp-large) {
    flex-direction: row;
    gap: 3.2rem;
  }
}

.relative-time {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-grayscale-light-slate);

  & > span {
    color: var(--color-grayscale-white);
  }

  @media screen and (max-width: #{$bp-medium - 1}) {
    display: none;
  }
}

.comment-drawer {
  min-height: 0;
  height: 100%;
  min-width: 0;
  width: 100%;
  scroll-behavior: smooth;

  @media screen and (min-width: $bp-medium) {
    width: 40rem;
    min-width: 40rem;
    max-width: 40rem;
  }
}
